
import { defineComponent, ref, reactive } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { getPlanDetail, postAdd, getUserSelectPlanList } from '@/http/caseForm';
import {
  CellGroup,
  Cell,
  Collapse,
  CollapseItem,
  Button,
  Checkbox,
  Field,
  Col,
  Row,
  Toast,
  ActionSheet,
  SwipeCell,
  Popup,
} from 'vant';

export default defineComponent({
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [ActionSheet.name]: ActionSheet,
    [SwipeCell.name]: SwipeCell,
    [Popup.name]: Popup,
  },
  setup(props) {
    const popupShow = ref(false);
    const pupupForm = reactive({
      reason: '',
      fasionDesc: '',
    });
    const pupupIndex = ref(0);
    const router = useRouter();
    const route = useRoute();
    const {
      projectId,
      time,
      type,
      status,
    } = route.query;
    const newType = ref(type);
    const userId = sessionStorage.getItem('userId');
    const details = ref({});
    const planData = ref({});
    const formData: any = ref([]);
    const headerList = ref([]);
    const selectIndex = ref(0);
    const state = reactive({
      palnListShow: false,
      palnList: [],
      selectPlanList: {},
    });
    const activeNames = ref(['0']);
    // 提交
    const onPost = () => {
      console.log(formData.value);
      let isLength = 0;
      const dataForm = JSON.parse(JSON.stringify(formData.value));
      const newArr: Array<any> = [];
      dataForm.forEach((item: any, index: number) => {
        const arr:[] = item.childPlans.filter((data: any) => (data.usesHours !== 0 && data.usesHours !== ''));
        console.log(arr);
        newArr.push(...item.childPlans);
        dataForm[index].childPlans = arr || [];
      });
      console.log(newArr);
      newArr.forEach((item:any) => {
        if (item.usesHours === 0 || item.usesHours === '') {
          isLength += 1;
        }
      });
      console.log(dataForm);
      if (isLength === newArr.length) {
        Toast('至少填写一个');
        return;
      }
      if (status === '1') {
        Toast('该项目已中断无法提交');
        return;
      }
      postAdd(dataForm).then((res) => {
        Toast('提交成功');
        setTimeout(() => {
          router.push({ path: '/' });
        }, 500);
      });
      console.log(formData.value);
    };
    const forData = (list: any) => {
      const data = list.map((item: any) => ({
        ...item,
        isDisabled: item.check,
        usesHours: item.usesHours || 0,
      }));
      return data;
    };
    const onSelectPlanName = () => {
      getUserSelectPlanList({ projectId: formData.value[0].pmId }).then((dataList: any) => {
        const list = dataList.result.map((item: any) => ({
          name: item.planName,
          id: item.id,
        }));
        state.palnListShow = true;
        state.palnList = list;
      });
    };
    // 获取当前
    const getData = (dataId: any) => {
      getPlanDetail({
        ids: dataId,
        type: newType.value,
        month: time || `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,
      }).then((res: any) => {
        console.log(res);
        const { result } = res;
        headerList.value = result.map((item: any) => item.project);
        result.forEach((item: any, index: number) => {
          formData.value.push({
            id: item.plan.id,
            fasionDesc: item.plan.fasionDesc,
            childPlans: forData(item.plan.childPlans),
            month: time,
            principal: item.plan.principal,
            planName: item.plan.planName,
            pmId: item.project.id,
            pmName: item.project.caseName,
          });
        });
        // const {
        //   result: { project, plan },
        // } = res;
        // const data = plan.childPlans.map((item: any) => ({
        //   reason: item.reason || '',
        //   usesHours: item.usesHours || '',
        //   id: item.id,
        //   check: item.check || '',
        //   isDisabled: item.check,
        // }));
        // formData.value.childPlans = data;
        // formData.value.fasionDesc = plan.fasionDesc;
        // details.value = project;
        // planData.value = plan;
        // getUserSelectPlanList({ projectId: project.id }).then(
        //   (dataList: any) => {
        //     const list = dataList.result.map((item: any) => ({
        //       name: item.planName,
        //       id: item.id,
        //     }));
        //     state.palnList = list;
        //   },
        // );
      });
    };
    const tabSelectIndex = () => {
      selectIndex.value += 1;
      if (selectIndex.value === headerList.value.length) {
        selectIndex.value = 0;
      }
    };
    const onSelectPaln = (item: any) => {
      state.selectPlanList = item;
      state.palnListShow = false;
      formData.value = [];
      newType.value = '1';
      getData(item.id);
    };
    const onCaseInfo = (id: any) => {
      router.push({
        path: '/caseInfo',
        query: { projectid: id },
      });
    };
    // 添加风险
    const onEdite = (index: number) => {
      pupupIndex.value = index;
      popupShow.value = true;
      pupupForm.reason = formData.value[0].childPlans[pupupIndex.value].reason;
      pupupForm.fasionDesc = formData.value[0].childPlans[pupupIndex.value].fasionDesc;
    };
    // 提交风险
    const onPopupOK = () => {
      formData.value[0].childPlans[pupupIndex.value].reason = pupupForm.reason;
      formData.value[0].childPlans[pupupIndex.value].fasionDesc = pupupForm.fasionDesc;
      console.log(formData.value);
      popupShow.value = false;
    };
    getData(projectId);
    return {
      details,
      planData,
      activeNames,
      formData,
      onPost,
      time,
      state,
      onSelectPaln,
      onCaseInfo,
      headerList,
      selectIndex,
      tabSelectIndex,
      userId,
      popupShow,
      onEdite,
      pupupForm,
      onPopupOK,
      onSelectPlanName,
    };
  },
});
